// extracted by mini-css-extract-plugin
module.exports = {"section":"homepage-featured-charts_section_36AOM"};